export type center ={
   lat:number
   lng:number
}

export type post = {
   displayName:string,
   id?:number,
   aid : number,
   verified:boolean,
   text:string,
   avatar:string,
   pic?:string,
   price?:string,
   location?:center,
   timestamp?:any
}

export type select = {
   name:string,
   loc:{
     lat:number,
     lng:number
   }
 }[]

 export type spot ={
   name?:string,
   location:{
       lat:number,
       lng:number
   }
   place?:string,
   spece?:string,
   money?:boolean,
   check:boolean,
   image?:string
}

export const SelectSpot :select =[
   {name:"京都",loc:{lat:48,lng:135}},
   {name:"大阪",loc:{lat:50,lng:138}},
   {name:"伊豆",loc:{lat:50,lng:138}},
   {name:"瀬戸内",loc:{lat:50,lng:138}},
   {name:"名古屋",loc:{lat:50,lng:138}},
   {name:"四国",loc:{lat:50,lng:138}},
   {name:"福岡",loc:{lat:50,lng:138}},
]

export const defaultSpots :spot[]=[
 {name:"伏見稲荷",place:"京都",spece:"history",money:false,check:false,location:{lat:34.9671178,lng:135.7726669},image:"https://souda-kyoto.jp/blog/ea410e000000c9rx-img/2.jpg"},
 {name:"通天閣",place:"大阪",spece:"eat",money:false,check:false,location:{lat:34.65253,lng:135.50631},image:"https://images.keizai.biz/abeno_keizai/headline/1658983694_photo.jpg"},
 {name:"宇治",place:"京都",spece:"history",money:false,check:false,location:{lat:34.88963,lng:135.80769},image:"https://travel.rakuten.co.jp/mytrip/sites/mytrip/files/migration_article_images/ranking/spot-uji-01-1.jpg"},
 {name:"熱海",place:"伊豆",spece:"eat",money:false,check:false,location:{lat:35.10477,lng:139.07936},image:"https://www.tabirai.net/sightseeing/article/img/0000198/kiji1Img.jpg"},
 {name:"渡月橋",place:"京都",spece:"eat",money:false,check:false,location:{lat:35.01316,lng:135.67772},image:"https://lh5.googleusercontent.com/p/AF1QipNkh8iYbSnCU5lLDdmd2dMYUfA2DmlMWQ1vhQRt=w408-h272-k-no"},
 {name:"京都タワー",place:"京都",spece:"eat",money:false,check:false,location:{lat:34.98773,lng:135.75929},image:"https://lh5.googleusercontent.com/p/AF1QipMNvIchog8yB5GuuIBoSigTBiVhl79OvwGhDzq1=w408-h303-k-no"},
 {name:"湯河原",place:"伊豆",spece:"eat",money:false,check:false,location:{lat:35.14643,lng:139.10039},image:"https://lh5.googleusercontent.com/p/AF1QipPme4ab3H6LwHuFkzRmwV4BbukhJr5IhrtVdcdl=w408-h306-k-no"}
]